import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'invoices',
    initialState: {invoices: [], invoice_single: false, message: false},
    reducers:{
        getInvoices: (state,action)=>{
            state.invoices = action.payload
        },
        getOneInvoice: (state,action)=>{
            state.invoice_single = action.payload
        },
        saveInvoice: (state,action)=>{
            state.invoices.unshift(action.payload)
            state.message = true
        },
        deleteToInvoice: (state,action)=>{
            state.invoices = state.invoices.filter(item=>item.id !== action.payload.id)
            state.message = 'deleted'
        },
        messageReset: (state,action)=>{
            state.message = false
        },
        messageFail: (state,action)=>{
            state.message = 'error'
        }
    }
})

export const getAllInvoices = (str) => apiCall({
    url: 'invoice/',
    method: 'GET',
    onSuccess: slice.actions.getInvoices.type
})

export const getAllThis = (data) => apiCall({
    url: "track/?getall="+data['part']+","+data['code'],
    method: 'GET',
    onSuccess: slice.actions.getInvoices.type,
    onFail: slice.actions.messageFail.type,
})

export const invoiceSave = (data) => apiCall({
    url: 'invoice/',
    method: 'POST',
    onSuccess: slice.actions.saveInvoice.type,
    onFail: slice.actions.messageFail.type,
    headers: {
        "Content-Type": "multipart/form-data",
    },
    data,
})

export const getInvoice = (id) => apiCall({
    url: 'invoice/'+id,
    method: 'GET',
    onSuccess: slice.actions.getOneInvoice.type,
})

export const deleteInvoice = (data) => apiCall({
    url: 'invoice/'+data.id+'/',
    method: 'DELETE',
    onSuccess: slice.actions.deleteToInvoice.type,
    onFail: slice.actions.messageFail.type,
})

export default slice.reducer
export const {messageReset} = slice.actions